import React from 'react';
import { Switch } from 'react-router-dom';

import { farmsRoute } from '~/routes'
import RouteWrapper from '~/routes/RouteWrapper';
import List from './List';
import Show from './Show';
import Edit from './Edit';
import New  from './New';

export default function FarmRoutesComponent() {
  return (
    <Switch>
      <RouteWrapper
        exact
        isPrivate
        path={farmsRoute.new.path}
        component={New}
        permissionKeyCode="Farm"
        permission="add"
      />
      <RouteWrapper
        exact
        isPrivate
        path={farmsRoute.clone.path}
        component={New}
        permissionKeyCode="Farm"
        permission="add"
      />
      <RouteWrapper
        exact
        isPrivate
        path={farmsRoute.show.path}
        component={Show}
        permissionKeyCode="Farm"
        permission="see"
      />
      <RouteWrapper
        exact
        isPrivate
        path={farmsRoute.edit.path}
        component={Edit}
        permissionKeyCode="Farm"
        permission="edit"
      />

      <RouteWrapper
        isPrivate
        redirectIfNotExact
        path={farmsRoute.list.path}
        component={List}
        permissionKeyCode="Farm"
        permission="see"
      />
    </Switch>
  );
}
